module.exports = __webpack_public_path__ + "static/icon_equity-6bb0eb3f263a22840213dfecf5a7d5c8.jpg";